import { Link } from 'react-router-dom';

export default function SpecComparison() {
  const specs = [
    {
      category: '年会費',
      rakuten: '永年無料',
      mitsui: '永年無料',
      winner: 'draw',
    },
    {
      category: '基本還元率',
      rakuten: '1.0%',
      mitsui: '0.5%',
      winner: 'rakuten',
    },
    {
      category: '特約店還元率',
      rakuten: '最大3.0%（ECモール）',
      mitsui: '最大7.0%（対象店舗）',
      winner: 'mitsui',
    },
    {
      category: '国際ブランド',
      rakuten: 'VISA / Mastercard / JCB / AMEX',
      mitsui: 'VISA / Mastercard',
      winner: 'rakuten',
    },
    {
      category: '審査難易度',
      rakuten: '比較的やさしい',
      mitsui: 'やや厳しめ',
      winner: 'rakuten',
    },
    {
      category: '発行スピード',
      rakuten: '約1週間',
      mitsui: '最短即日',
      winner: 'mitsui',
    },
    {
      category: '旅行保険',
      rakuten: '海外旅行傷害保険（利用付帯）',
      mitsui: '海外旅行傷害保険（利用付帯）',
      winner: 'draw',
    },
    {
      category: 'ポイント交換先',
      rakuten: 'ポイント（経済圏で利用）',
      mitsui: 'Vポイント（多様な交換先）',
      winner: 'draw',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            基本スペック比較表
          </h2>
          <p className="text-gray-600">
            主要項目を一覧で比較。それぞれの強みと弱みが一目でわかります
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border-2 border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-to-r from-gray-50 to-gray-100">
                  <th className="px-6 py-4 text-left text-sm font-bold text-gray-900 border-b-2 border-gray-200">
                    比較項目
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-bold text-rose-700 border-b-2 border-gray-200 bg-rose-50">
                    大手ECモール系カード
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-bold text-teal-700 border-b-2 border-gray-200 bg-teal-50">
                    三井住友カード（NL）
                  </th>
                </tr>
              </thead>
              <tbody>
                {specs.map((spec, index) => (
                  <tr key={index} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 text-sm font-bold text-gray-900 border-b border-gray-200">
                      {spec.category}
                    </td>
                    <td className={`px-6 py-4 text-sm text-center border-b border-gray-200 ${
                      spec.winner === 'rakuten' ? 'bg-rose-50 font-bold text-rose-700' : 'text-gray-700'
                    }`}>
                      {spec.rakuten}
                      {spec.winner === 'rakuten' && (
                        <span className="ml-2 text-rose-600">👑</span>
                      )}
                    </td>
                    <td className={`px-6 py-4 text-sm text-center border-b border-gray-200 ${
                      spec.winner === 'mitsui' ? 'bg-teal-50 font-bold text-teal-700' : 'text-gray-700'
                    }`}>
                      {spec.mitsui}
                      {spec.winner === 'mitsui' && (
                        <span className="ml-2 text-teal-600">👑</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-rose-50 border-2 border-rose-200 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-rose-600 rounded-lg flex items-center justify-center">
                <i className="ri-trophy-line text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900">大手ECモール系カードの強み</h3>
            </div>
            <ul className="space-y-2">
              <li className="flex items-start gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-rose-600 mt-0.5"></i>
                <span>基本還元率1.0%で常に高還元</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-rose-600 mt-0.5"></i>
                <span>ECモールでポイント最大3倍</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-rose-600 mt-0.5"></i>
                <span>審査が比較的やさしい</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-rose-600 mt-0.5"></i>
                <span>国際ブランドの選択肢が豊富</span>
              </li>
            </ul>
          </div>

          <div className="bg-teal-50 border-2 border-teal-200 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
                <i className="ri-trophy-line text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900">三井住友カードの強み</h3>
            </div>
            <ul className="space-y-2">
              <li className="flex items-start gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-teal-600 mt-0.5"></i>
                <span>対象店舗で最大7%還元</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-teal-600 mt-0.5"></i>
                <span>最短即日発行可能</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-teal-600 mt-0.5"></i>
                <span>信頼のブランド力とセキュリティ</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-teal-600 mt-0.5"></i>
                <span>ナンバーレスで安心</span>
              </li>
            </ul>
          </div>
        </div>

        {/* 2️⃣ 比較表下部にCTA追加 */}
        <div className="mt-8 bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border-2 border-gray-200">
          <div className="text-center">
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              各カードの詳細をチェック
            </h3>
            <p className="text-gray-600 mb-6">
              より詳しい情報は各カードの詳細ページでご確認いただけます
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/rakuten"
                className="inline-flex items-center justify-center gap-2 bg-rose-600 text-white font-bold px-8 py-4 rounded-xl hover:bg-rose-700 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-shopping-bag-3-line"></i>
                大手ECモール系カードの詳細
              </Link>
              <Link
                to="/mitsui"
                className="inline-flex items-center justify-center gap-2 bg-teal-600 text-white font-bold px-8 py-4 rounded-xl hover:bg-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-shield-check-line"></i>
                三井住友カードの詳細
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
